<template>
  <div class="customer-list">
    <refresh-list
      @onLoad="onLoad"
      :list="list"
      @onRefresh="init"
      ref="refreshList"
    >
      <van-collapse v-model="activeName" accordion>
        <van-collapse-item
          :name="index"
          :is-link="false"
          v-for="(item, index) in list"
          :key="index"
        >
          <template #title>
            <div class="title">
              <div class="title-left">
                <div class="name">下载名称：{{ item.fileName}}</div>
                <div class="number">下载时间：{{ item.createdTime }}</div>
              </div>
              <div class="title-right">
                <span>状态：</span>
                <span>{{ item.status | status}}</span>
                <div class="color" :class="{'failed-color': item.status == 3}" v-if="item.status != 1" @click="download(item)">
                  {{item.status == 2 ? '下载文件': '失败原因' }}
                </div>
               
              </div>
            </div>
          </template>
          <div class="content">
            <div class="list">
              <span class="list-left">文件名称</span>
              <span class="list-right">{{ item.fileName }}</span>
            </div>
            <div class="list">
              <span class="list-left">下载人</span>
              <span class="list-right">{{ item.createdByName }}</span>
            </div>
            <div class="list">
              <span class="list-left">下载微信id</span>
              <span class="list-right">{{ item.unionId}}</span>
            </div>
            <div class="list">
              <span class="list-left">状态</span>
              <span class="list-right">{{ item.status | status}}</span>
            </div>
          </div>
        </van-collapse-item>
      </van-collapse>
      
    </refresh-list>
    <div style="height: 80px;"></div>
    <div class="footer">
      <div class="button" @click="back">返回</div>
      <div class="button bgd" @click="refresh">刷新</div>
    </div>
  </div>
</template>

<script>
import dayjs from "@/utils/dayjs";
import refreshList from "@/components/refresh-list/refresh-list";
export default {
  components: {
    refreshList,
  },
  data() {
    return {
      activeName: "1",
      list: [],
      pageNum: 1,
      pageSize: 20,
      isClick: true
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    onLoad() {
      this.getList();
    },
    refresh() {
     if (this.isClick) {
      this.isClick = false
      this.init();
     }
    },
    init() {
      this.pageNum = 1;
      this.list = [];
      this.getList();
    },
    getList() {
      let data = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      };
      this.$api.activityMgmt
        .selectReportRecordList(data)
        .then((res) => {
          if (res.code == 200) {
            const list = res.data.list.map((item) => ({
              ...item,
              showPopover: false,
            }));
            this.list.push(...list);
            this.pageNum = res.data.pageNum + 1;
            this.$refs["refreshList"].complete(res.data);
          } else {
            this.$refs["refreshList"].onFinish();
          }
        })
        .catch((err) => {
          this.$refs["refreshList"].onFinish();
        }).finally(_ => {
            setTimeout(() => {
              this.isClick = true
            },500)
          })
    },
    download(item) {
      const { status, downloadUrl,fileName,reason } = item
      if (status == 2) {
        this.downloadFile(downloadUrl,fileName)
      } else {
        this.$dialog.alert({
          title: '失败原因',
          message: reason,
        })
      }
    },
     // 二进制流文件下载
    downloadFile(fileUrl, fileName) {
      const link = document.createElement("a");
      link.style.display = "none";
      link.href = fileUrl;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    back() {
      this.$router.go(-1)
    },
  },
  filters: {
    status(value) {
      let map = {1:'导出中', 2:'成功', 3:'失败'}
      return map[value]
    }
  }
};
</script>
<style lang="stylus" scoped>
.customer-list {
  .van-pull-refresh {
    min-height: 100vh;
    .title {
      display: flex;
      justify-content: space-between;
      .title-left {
        color: #333333;
        font-size: 14px;
        width: 230px;
        .number {
          color: #999999;
          font-size: 13px
        }
      }
      .title-right {
        .color {
          color: #fff;
          border-radius: 4px;
          text-align: center;
          background: linear-gradient(180deg, #FF8820 0%, #FF6B31 100%);
        }
        .failed-color {
          background: #ccc;
        }
      }
      
    }
    .content {
      .list {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        height: 44px;
        color: #999999;
        font-size: 14px;
        .list-right {
          display: flex;
          justify-content: flex-end;
          color: #333333;
          width: 260px;
        }
      }
    }
  }
  .footer {
    position: fixed;
    bottom: 0;
    display: flex;
    justify-content: space-around;
    width: 100%;
    height: 84px;
    background: #FFFFFF;
    box-shadow: 0px -3px 9px 0px rgba(220, 220, 220, 0.3);
    .button {
      width: 138px;
      height: 43px;
      font-size: 17px;
      color: #FF6B31;
      text-align: center;
      line-height: 43px;
      border-radius: 8px;
      border: 1px solid #FF6B31;
      margin-top: 10px;
    }
    .bgd {
      color: #FFFFFF;
      background: #FF6B31;
    }
  }
}
</style>
